import { getModuleListForRemind } from '@/api/module';
import { getTodoListForRemind } from '@/api/todo';
import router from '@/router';
import moment from 'moment';
import { classifyModuleList } from './module';
import { scheduleJob } from './schedule';
import storage from './storage';
import { getAccount } from './user';
import { AccountModule } from '@/store/modules/account';
import { INotificationContent, winNotification } from './winNotification';
import i18n from '@/lang';
import { noticeMessage } from './signalr';
import { todoListInstance } from '@/model/TodoListClass';
import { grabTodoListInstance } from '@/model/GrabTodoListClass';
import { releaseTodoListInstance } from '@/model/ReleaseTodoListClass';

const REMIND_CHECK_TODO_TIME = 'REMIND_CHECK_TODO_TIME';
const REMIND_SETTLEMENT_MODULE_TIME = 'REMIND_SETTLEMENT_MODULE_TIME';
const WITHIN_THREE_DAY_MODULE_ID_ARR = 'WITHIN_THREE_DAY_MODULE_ID_ARR';


const addAccountName = (str: string): string => {
  const accountName = getAccount().mobile;
  return `${str}_${accountName}`;
};

const remindCheckTodo = () => {
  storage.localSet(addAccountName(REMIND_CHECK_TODO_TIME), new Date());
  getTodoListForRemind()
    .then((res) => {
      if (res.data.length > 0) {
        const notificationInfo: INotificationContent = {
          title: 'Lucky PM',
          body: i18n.t('remind.checkTodo').toString(),
          key: 'CheckTodo',
          onClick: () => {
            if (router.currentRoute.name !== 'Todo') {
              router.push({ name: 'Todo' });
            }
          },
        };
        winNotification.sendNotification(notificationInfo);
      }
    })
    .catch((err) => err);
};
const remindSettlementModuleByToday = () => {
  const notificationInfo: INotificationContent = {
    title: 'Lucky PM',
    body: i18n.t('remind.settlementModuleByToday').toString(),
    key: 'SettlementModuleByToday',
    onClick: () => {
      if (router.currentRoute.name !== 'Module') {
        router.push({ name: 'Module' });
      }
    },
  };
  winNotification.sendNotification(notificationInfo);
};
const remindSettlementModuleByWithinThreeDay = (newModuleIdArr: string[]) => {
  const oldModuleIdArr: string[] =
    storage.localGet(WITHIN_THREE_DAY_MODULE_ID_ARR) || [];
  const notificationInfo: INotificationContent = {
    title: 'Lucky PM',
    body: i18n.t('remind.settlementModuleByWithinThreeDay').toString(),
    key: 'SettlementModuleByWithinThreeDay',
    onClick: () => {
      if (router.currentRoute.name !== 'Module') {
        router.push({ name: 'Module' });
      }
    },
  };
  if (oldModuleIdArr.length > 0) {
    if (newModuleIdArr.some((moduleId) => !oldModuleIdArr.includes(moduleId))) {
      winNotification.sendNotification(notificationInfo);
      storage.localSet(WITHIN_THREE_DAY_MODULE_ID_ARR, newModuleIdArr);
    }
  } else {
    winNotification.sendNotification(notificationInfo);
    storage.localSet(WITHIN_THREE_DAY_MODULE_ID_ARR, newModuleIdArr);
  }
};
export const registerCheckTodoSchedule = () => {
  const INTERVAL_TIME = 2 * 60 * 60; // 单位：秒
  const remindTime = storage.localGet(addAccountName(REMIND_CHECK_TODO_TIME));
  const pastSeconds = remindTime
    ? moment().diff(moment(remindTime), 'seconds')
    : INTERVAL_TIME;
  const startRemind = () => {
    remindCheckTodo();
    scheduleJob('remindCheckTodo', INTERVAL_TIME, remindCheckTodo);
  };
  if (pastSeconds >= INTERVAL_TIME) {
    // 过去时间超过间隔时间，立即触发提醒
    startRemind();
  } else {
    // 等到间隔时间，才触发提醒
    setTimeout(() => {
      startRemind();
    }, (INTERVAL_TIME - pastSeconds) * 1000);
  }
};
const remindSettlementModule = () => {
  storage.localSet(addAccountName(REMIND_SETTLEMENT_MODULE_TIME), new Date());
  getModuleListForRemind()
    .then((res) => {
      if (res.data.length > 0) {
        const classifyModule = classifyModuleList(res.data);
        if (classifyModule.listByToday.length > 0) {
          remindSettlementModuleByToday();
        }
        if (classifyModule.listByOther.length > 0) {
          const newModuleIdArr = classifyModule.listByOther.map(
            (item) => item.id,
          );
          // 错开提醒
          setTimeout(() => {
            remindSettlementModuleByWithinThreeDay(newModuleIdArr);
          }, 500);
        }
      }
    })
    .catch((err) => err);
};
export const registerSettlementModuleSchedule = () => {
  const INTERVAL_TIME = 6 * 60 * 60; // 单位：秒
  const remindTime = storage.localGet(
    addAccountName(REMIND_SETTLEMENT_MODULE_TIME),
  );
  const pastSeconds = remindTime
    ? moment().diff(moment(remindTime), 'seconds')
    : INTERVAL_TIME;
  const startRemind = () => {
    remindSettlementModule();
    scheduleJob(
      'remindSettlementModule',
      INTERVAL_TIME,
      remindSettlementModule,
    );
  };
  if (pastSeconds >= INTERVAL_TIME) {
    // 过去时间超过间隔时间，立即触发提醒
    startRemind();
  } else {
    // 等到间隔时间，才触发提醒
    setTimeout(() => {
      startRemind();
    }, (INTERVAL_TIME - pastSeconds) * 1000);
  }
};

export const remindByTodayTodo = () => {
  const remindByCompleteTodo = () => {
    const notificationInfo: INotificationContent = {
      title: 'Lucky PM',
      body: i18n.t('remind.isCompletedTodo').toString(),
      key: 'CompleteTodo',
      onClick: () => {
        if (router.currentRoute.name !== 'Todo') {
          router.push({ name: 'Todo' });
        }
      },
    };
    winNotification.sendNotification(notificationInfo);
  };
  const remindByUnfinishedTodo = () => {
    const notificationInfo: INotificationContent = {
      title: 'Lucky PM',
      body: i18n.t('remind.haveUnfinishedTodo').toString(),
      key: 'UnfinishedTodo',
      onClick: () => {
        if (router.currentRoute.name !== 'Todo') {
          router.push({ name: 'Todo' });
        }
      },
    };
    winNotification.sendNotification(notificationInfo);
  };
  getTodoListForRemind()
    .then((res) => {
      if (res.todayCompleteTodos.length > 0) {
        remindByCompleteTodo();
      }
      if (res.moreThanCompleteDateTodos.length > 0) {
        // 错开提醒
        setTimeout(() => {
          remindByUnfinishedTodo();
        }, 500);
      }
    })
    .catch((err) => err);
};
export const registerRemindByNewTodo = () => {
  const remindByNewTodo = () => {
    const notificationInfo: INotificationContent = {
      title: 'Lucky PM',
      body: i18n.t('remind.haveNewTodo').toString(),
      key: 'NewTodo',
      onClick: () => {
        if (router.currentRoute.name !== 'Todo') {
          router.push({ name: 'Todo' });
        }
      },
    };
    winNotification.sendNotification(notificationInfo);
  };
  const remindByGrabTodo = () => {
    const notificationInfo: INotificationContent = {
      title: 'Lucky PM',
      body: i18n.t('remind.haveNewGrabTodo').toString(),
      key: 'NewTodo',
      onClick: () => {
        if (router.currentRoute.name !== 'GrabTodo') {
          router.push({
            name: 'GrabTodo',
            params: {
              tabKey: 'grab',
            },
          });
        }
      },
    };
    winNotification.sendNotification(notificationInfo);
  };
  noticeMessage('batchAdd', (data: ITodo.IResponse.IGrabTodoInfo[]) => {
    const accountId = AccountModule.userDetailInfo?.id;
    const teamIds = AccountModule.userDetailInfo ? AccountModule.userDetailInfo.teams.map((team) => team.id) : [];
    if (data.some((todo) => todo.patternType === 0 && todo.owner === accountId)) {
      todoListInstance.remindRefresh = true;
      remindByNewTodo();
    }
    if (data.some((todo) => todo.patternType === 1 && todo.teamIds.some((id) => teamIds.includes(id)))) {
      grabTodoListInstance.requestGrabTodoList();
      remindByGrabTodo();
    }
  });
  noticeMessage('batchUpdate', (data: ITodo.IResponse.IGrabTodoInfo[]) => {
    const accountId = AccountModule.userDetailInfo?.id;
    const teamIds = AccountModule.userDetailInfo ? AccountModule.userDetailInfo.teams.map((team) => team.id) : [];
    if (data.some((todo) => todo.patternType === 0 && todo.owner === accountId)) {
      todoListInstance.remindRefresh = true;
      remindByNewTodo();
    }
    if (data.some((todo) => todo.patternType === 1 && todo.teamIds.some((id) => teamIds.includes(id)))) {
      grabTodoListInstance.requestGrabTodoList();
      remindByGrabTodo();
    }
  });
};
export const registerRemindByAcceptTodo = () => {
  const remindByAcceptTodo = (todoId: string) => {
    const notificationInfo: INotificationContent = {
      title: 'Lucky PM',
      body: i18n.t('remind.grabTodoHasAccepted').toString(),
      key: 'AcceptTodo',
      onClick: () => {
        if (router.currentRoute.name !== 'GrabTodo') {
          router.push({
            name: 'GrabTodo',
            params: {
              tabKey: 'release',
              id: todoId,
            },
          });
        }
      },
    };
    winNotification.sendNotification(notificationInfo);
  };
  noticeMessage('garbTodoEvent', (data: {createBy: string, todoId: string}) => {
    const accountId = AccountModule.userDetailInfo?.id;
    if (data.createBy === accountId) {
      releaseTodoListInstance.requestGrabTodoList();
      remindByAcceptTodo(data.todoId);
    }
  });
};
